/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hakkimizda_S5_Written_OrInputs */

const tr_hakkimizda_s5_written_or = /** @type {(inputs: Hakkimizda_S5_Written_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`veya`)
};

const en_hakkimizda_s5_written_or = /** @type {(inputs: Hakkimizda_S5_Written_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or our`)
};

const de_hakkimizda_s5_written_or = /** @type {(inputs: Hakkimizda_S5_Written_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oder unsere Seite`)
};

const ru_hakkimizda_s5_written_or = /** @type {(inputs: Hakkimizda_S5_Written_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`или наша страница`)
};

/**
* | output |
* | --- |
* | "or our" |
*
* @param {Hakkimizda_S5_Written_OrInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const hakkimizda_s5_written_or = /** @type {((inputs?: Hakkimizda_S5_Written_OrInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hakkimizda_S5_Written_OrInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hakkimizda_s5_written_or(inputs)
	if (locale === "de") return de_hakkimizda_s5_written_or(inputs)
	if (locale === "ru") return ru_hakkimizda_s5_written_or(inputs)
	return tr_hakkimizda_s5_written_or(inputs)
});